import React, { ReactNode } from 'react';
import styles from './FloFormGroup.module.css';
import classnames from 'classnames';
import { FloComponentProps } from 'components';
import { Form } from 'react-bootstrap';

interface FloFormGroupProps extends FloComponentProps {
  controlId:  string;
  children:   ReactNode;
  label:      string;
  touched:    { [key: string]: boolean | undefined };
  errors:     { [key: string]: string | undefined };
}

export const FloFormGroup: React.FC<FloFormGroupProps> =  React.memo(({
  children,
  className,
  label,
  controlId,
  touched,
  errors
}) => {
  return (
    <Form.Group
      controlId = {controlId}
      className = {classnames(styles.root, className)}
    >
      <Form.Label className={styles.label}>{label}</Form.Label>
      {children}
      { touched[controlId] && errors[controlId] &&
        <Form.Text className={styles.errorMessage}>{errors[controlId]}</Form.Text> }
    </Form.Group>
  );
});

export default FloFormGroup;